import PropTypes from 'prop-types';

export const classificationItemPropType = {
  id: PropTypes.string,
  code: PropTypes.string,
  displayName: PropTypes.string,
  image: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    alt: PropTypes.string,
    mediaProperty: PropTypes.string,
    itemKey: PropTypes.string,
    image: PropTypes.shape({
      mediaUrl: PropTypes.string.isRequired,
      alt: PropTypes.string,
      lazyLoad: PropTypes.boolean,
      dimensions: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      focalPoint: PropTypes.shape({
        left: PropTypes.number,
        leftPixel: PropTypes.number,
        top: PropTypes.number,
        topPixel: PropTypes.number,
      }),
    }),
    cacheable: PropTypes.bool,
  }),
};

export const activeFilterStepPropType = {
  index: PropTypes.number,
  id: PropTypes.string,
};

export const filtersPropType = {
  selectedPrimaryClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedSecondaryClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedLocations: PropTypes.string,
  selectedFlightTime: PropTypes.string,
  selectedTemperature: PropTypes.string,
  selectedTemperaturePeriod: PropTypes.string,
  selectedPreference: PropTypes.string,
};
